import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatRadioModule } from "@angular/material/radio";
import { MatFormFieldModule } from "@angular/material/form-field";
import { TranslateModule } from "@ngx-translate/core";
import { MatInputModule } from "@angular/material/input";
import { ThreeOptionsAnswer } from "libs/questionaire/src/lib/orcadent/models/questionnaire-orcadent.model";

@Component({
	selector: "three-options-form",
	standalone: true,
	imports: [
		CommonModule,
		MatRadioModule,
		MatFormFieldModule,
		MatInputModule,
		TranslateModule,
		ReactiveFormsModule,
	],
	templateUrl: "./threeOptionsForm.component.html",
	styleUrl: "./threeOptionsForm.component.scss"
})
export class ThreeOptionsFormComponent implements OnInit, OnChanges {
	@Input({required: true}) parentForm: FormGroup;
	@Input({required: true}) nestedFormGroupName: string;
	@Input({required: true}) isUpperJaw: boolean;
	@Input({required: true}) answerRecord: Record<ThreeOptionsAnswer, string>;
	@Input() isRequired: boolean;

	ThreeOptionsAnswer = ThreeOptionsAnswer;

	jawFormControlName: string;
	optionFormControl: FormControl;
	textFormControl: FormControl;

	ngOnInit(): void {
		//set en-/disabled state depending on value (e.g. should not be disabled when form is prefilled)
		if(this.textFormControl.value){
			this.textFormControl.enable({emitEvent: false});
		}else{
			this.textFormControl.disable({emitEvent: false});
		}

		this.optionFormControl?.valueChanges.subscribe((value) => {
			if(value === ThreeOptionsAnswer.OTHER){
				this.textFormControl?.enable({emitEvent: false});
				this.textFormControl?.setValidators([Validators.required]);
				this.textFormControl?.markAsTouched();
			} else {
				this.textFormControl?.patchValue("", { emitEvent: false });
				this.textFormControl?.disable({emitEvent: false});
				this.textFormControl?.clearValidators();
			}
			this.textFormControl?.updateValueAndValidity();
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.jawFormControlName = this.isUpperJaw ? "uj" : "lj";
		this.optionFormControl = this.parentForm.get(
			`${this.nestedFormGroupName}.${this.jawFormControlName}.option`
		) as FormControl;
		this.textFormControl = this.parentForm.get(
			`${this.nestedFormGroupName}.${this.jawFormControlName}.text`
		) as FormControl;

		//special handling for forms that have an dedicated flag to determine
		//whether it is required or not
		if (changes["isRequired"]) {
			if (this.isRequired) {
				this.optionFormControl.enable({ emitEvent: false });
				this.optionFormControl.addValidators([Validators.required]);
			} else {
				this.textFormControl.disable({ emitEvent: false });
				this.textFormControl.patchValue(null, { emitEvent: false });
				this.optionFormControl.disable({ emitEvent: false });
				this.optionFormControl.patchValue(null, { emitEvent: false });
				this.optionFormControl.clearValidators();
			}
			this.optionFormControl.updateValueAndValidity({ emitEvent: false });
		}
	}

}

